import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
  query FilmToPersonRelationshipTypes ($limit: Int, $offset: Int, $value: Value, $valueKey: String, $op: String) {
    FilmToPersonRelationshipTypes(limit: $limit, valueKey: $valueKey, value: $value, offset: $offset, op: $op) {
      relationshipTypeID
      RelationshipType {
        ...fragRelationshipTypeDetail
      }
    }
  }
  ${fragments.fragRelationshipTypeDetail}

  `

  
